import React from "react";
import { useTranslation } from "../hooks/useTranslation";

function format(value) {
  if (value === null || value === undefined || value === "") return "-";
  const num = Number(value);
  if (!Number.isFinite(num)) return "-";
  return new Intl.NumberFormat("sv-SE", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(num);
}

const MealPriceTotalComponent = ({ totalCost }) => {
  const { t } = useTranslation();
  const hasTotalCost =
    totalCost !== null &&
    totalCost !== undefined &&
    totalCost !== "" &&
    Number.isFinite(Number(totalCost));

  return (
    <div className="w-[94%] max-w-xs rounded-lg border border-gray-200 bg-white px-3 py-2 mx-auto">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium text-gray-500">{t("Total kostnad")}</span>
        <span className="text-xs   text-gray-500">
          {hasTotalCost ? (
            <>
              {format(totalCost)} <span className="text-xs font-medium text-gray-500">kr</span>
            </>
          ) : (
            <span className="text-amber-600 text-xs font-medium">{t("Ofullständig")}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default MealPriceTotalComponent;
